import script from "./PantallaAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaAdmin.vue?vue&type=script&setup=true&lang=js"

import "./PantallaAdmin.vue?vue&type=style&index=0&id=1b1d287a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1d287a"]])

export default __exports__